import {
  Button,
  ButtonGroup,
  ConfirmationModal,
  ModalBody,
  Paragraph,
} from "@george-labs.com/design-system"
import { MODAL_CONFIRMATION_TYPE } from "@george-labs.com/design-system/types/components/Modal"
import { ICON } from "@george-labs.com/george-assets/icons"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"

interface IModalProps {
  text: string
  title?: string
  type: "success" | "error" | "info"
  disableCancel?: boolean
  closeable?: boolean
  className?: string
  cancelButtonText?: string
  confirmButtonText?: string
  confirmationIcon?: ICON
  closeLabel?: string
  onClose: () => void
  onClick: () => void
}

const getConfirmationType = (type: string): MODAL_CONFIRMATION_TYPE => {
  if (type === "success") {
    return ConfirmationModal.CONFIRMATION_TYPE.SUCCESS
  }

  return type === "error"
    ? ConfirmationModal.CONFIRMATION_TYPE.ERROR
    : ConfirmationModal.CONFIRMATION_TYPE.INFO
}

const ModalComponent = (props: IModalProps) => {
  const { t } = useTranslation()
  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    setIsOpen(true)

    return () => {
      setIsOpen(false)
    }
  }, [])

  const confirmationType = getConfirmationType(props.type)

  return (
    <ConfirmationModal
      onClose={props.onClose}
      className={`${props.className} p-3`}
      closeable={props.closeable ? props.closeable : true}
      isOpen={isOpen}
      animate={true}
      confirmationType={confirmationType}
      confirmationIcon={props.confirmationIcon}
      closeLabel={props.closeLabel ? props.closeLabel : t("common.close")}
      title={props.title ? props.title : t("common.required.title")}
      footer={
        <ButtonGroup>
          {!props.disableCancel && (
            <Button
              onClick={props.onClose}
              variant={Button.VARIANT.SECONDARY}
              disabled={false}
            >
              {props.cancelButtonText
                ? props.cancelButtonText
                : t("common.button.cancel")}
            </Button>
          )}
          <Button onClick={props.onClick} disabled={false}>
            {props.confirmButtonText
              ? props.confirmButtonText
              : t("common.button.ok")}
          </Button>
        </ButtonGroup>
      }
    >
      <ModalBody>
        <Paragraph>{props.text}</Paragraph>
      </ModalBody>
    </ConfirmationModal>
  )
}

export default ModalComponent
